module.exports = __webpack_public_path__ + "signup_photo.jpg";